import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    class: 'ineligible',
    field: 'menHairLoss_archived_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    educationalSlide: '',
    type: 'info',
    isLast: true,
    answer: {}
  },
  {
    label: 'What was your sex assigned at birth?',
    field: 'menHairLoss_archived_sexAssignedAtBirth',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_archived_sexAssignedAtBirth_male',
          value: 'Male'
        },
        {
          key: 'menHairLoss_archived_sexAssignedAtBirth_female',
          value: 'Female'
        }
      ]
    }
  },
  {
    label: 'What is your height in feet and inches?',
    field: 'menHairLoss_archived_height',
    type: 'info',
    answer: {
      name: 'menHairLoss_archived_height_ans',
      type: 'text',
      placeholder: 'Feet and inches'
    }
  },
  {
    label: 'What is your weight in pounds?',
    field: 'menHairLoss_archived_weight',
    type: 'info',
    answer: {
      name: 'menHairLoss_archived_weight_ans',
      type: 'number',
      placeholder: 'Pounds'
    }
  },
  {
    label: 'Please identify all your current medical conditions',
    field: 'menHairLoss_archived_currentMedicalConditions',
    type: 'info',
    answer: {
      name: 'menHairLoss_archived_currentMedicalConditions_ans',
      type: 'text',
      placeholder: 'Medical conditions'
    }
  },
  {
    label: 'Please list all your current medications including dosages',
    field: 'menHairLoss_archived_currentMedications',
    type: 'info',
    answer: {
      name: 'menHairLoss_archived_currentMedications_ans',
      type: 'text',
      placeholder: 'Medications'
    }
  },
  {
    label: 'Please list all of your known allergies',
    field: 'menHairLoss_archived_knownAllergies',
    type: 'info',
    answer: {
      name: 'menHairLoss_archived_knownAllergies_ans',
      type: 'text',
      placeholder: 'Allergies'
    }
  },
  {
    label: 'Which areas are affected by hair loss?',
    field: 'menHairLoss_archived_affectedAreas',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_archived_affectedAreas_recedingHairline',
          value: 'Receding hairline'
        },
        {
          key: 'menHairLoss_archived_affectedAreas_thinningAtCrown',
          value: 'Thinning at the crown'
        },
        {
          key: 'menHairLoss_archived_affectedAreas_overallThinning',
          value: 'Overall thinning'
        },
        {
          key: 'menHairLoss_archived_affectedAreas_other',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'menHairLoss_archived_affectedAreas_other_ans',
            placeholder: 'Tell us more about the pattern of your hair loss'
          }
        }
      ]
    }
  },
  {
    label: 'How long have you been experiencing hair loss?',
    field: 'menHairLoss_archived_howLongHaveYouBeenExperiencingHairLoss',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_archived_howLongHaveYouBeenExperiencingHairLoss_lessThan6Months',
          value: 'Less than 6 months'
        },
        {
          key: 'menHairLoss_archived_howLongHaveYouBeenExperiencingHairLoss_6MonthsTo1Year',
          value: '6 months to 1 year'
        },
        {
          key: 'menHairLoss_archived_howLongHaveYouBeenExperiencingHairLoss_over1Year',
          value: 'Over 1 year'
        }
      ]
    }
  },
  {
    label: 'How much hair have you lost?',
    field: 'menHairLoss_archived_howMuchHairHaveYouLost',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_archived_howMuchHairHaveYouLost_aLittle',
          value: 'A little (Only I notice it)'
        },
        {
          key: 'menHairLoss_archived_howMuchHairHaveYouLost_some',
          value: 'Some (Those close to me notice it)'
        },
        {
          key: 'menHairLoss_archived_howMuchHairHaveYouLost_aLot',
          value: 'A lot (It is obvious to everyone)'
        }
      ]
    }
  },
  {
    label: ' Do you believe your hair loss is due to:',
    field: 'menHairLoss_archived_hairLossCause',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_archived_hairLossCause_genetics',
          value: 'Genetics'
        },
        {
          key: 'menHairLoss_archived_hairLossCause_stress',
          value: 'Stress'
        },
        {
          key: 'menHairLoss_archived_hairLossCause_medicalConditions',
          value: 'Medical conditions'
        },
        {
          key: 'menHairLoss_archived_hairLossCause_medications',
          value: 'Medications'
        },
        {
          key: 'menHairLoss_archived_hairLossCause_nutritionalDeficiencies',
          value: 'Nutritional deficiencies'
        },
        {
          key: 'menHairLoss_archived_hairLossCause_other',
          value: 'Other',
          answer: {
            rows: 3,
            type: 'text',
            name: 'menHairLoss_archived_hairLossCause_other_ans',
            placeholder: 'Tell us more about why you think you’re losing hair.'
          }
        }
      ]
    }
  },
  {
    label:
      'Do you have any scalp conditions such as psoriasis, dermatitis, and/or recent or current scalp infections?',
    field: 'menHairLoss_archived_scalpConditions',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_archived_scalpConditions_yes',
          value: 'Yes'
        },
        {
          key: 'menHairLoss_archived_scalpConditions_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Do you have excessive dandruff, scalp irritation, scalp redness, burning, pustules, or scarring?',
    field: 'menHairLoss_archived_scalpIrritation',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_archived_scalpIrritation_yes',
          value: 'Yes'
        },
        {
          key: 'menHairLoss_archived_scalpIrritation_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Are you losing hair in different parts of your body?',
    field: 'menHairLoss_archived_hairLossInDifferentPartsOfBody',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_archived_hairLossInDifferentPartsOfBody_yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'menHairLoss_archived_hairLossInDifferentPartsOfBody_yes_ans',
            placeholder:
              'Tell us more about your hair loss in other parts of your body.'
          }
        },
        {
          key: 'menHairLoss_archived_hairLossInDifferentPartsOfBody_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Have you tried any treatments for hair loss before?',
    field: 'menHairLoss_archived_hairLossTreatments',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_archived_hairLossTreatments_yes',
          value: 'Yes',
          answer: {
            type: 'text',
            rows: 3,
            name: 'menHairLoss_archived_hairLossTreatments_yes_ans',
            placeholder:
              'Tell us more about your previous treatment including product use, when, duration of use, and did you experience side effects?'
          }
        },
        {
          key: 'menHairLoss_archived_hairLossTreatments_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Do you have any of the following medical conditions? (check all that apply)',
    field: 'menHairLoss_archived_medicalConditions',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_archived_medicalConditions_prostateCancer',
          value: 'Current or history of prostate cancer'
        },
        {
          key: 'menHairLoss_archived_medicalConditions_liverCirrhosis',
          value: 'Liver disease such as liver cirrhosis'
        },
        {
          key: 'menHairLoss_archived_medicalConditions_kidneyDisease',
          value:
            'Kidney disease such as chronic kidney disease or kidney failure'
        },
        {
          key: 'menHairLoss_archived_medicalConditions_heartConditions',
          value: 'Heart conditions or cardiovascular diseases'
        },
        {
          key: 'menHairLoss_archived_medicalConditions_stroke',
          value: 'History of stroke'
        },
        {
          key: 'menHairLoss_archived_medicalConditions_pheochromocytoma',
          value: 'Pheochromocytoma (adrenal gland tumor)'
        },
        {
          key: 'menHairLoss_archived_medicalConditions_pulmonaryHypertension',
          value: 'Pulmonary hypertension Erectile Dysfunction'
        },
        {
          key: 'menHairLoss_archived_medicalConditions_none',
          value: 'None of these apply to me'
        }
      ]
    }
  },
  {
    label:
      'Do you have a history of depression, bipolar disorder, anxiety, or other mood disorders?',
    field: 'menHairLoss_archived_moodDisorders',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_archived_moodDisorders_yes',
          value: 'Yes',
          answer: {
            type: 'text',
            rows: 3,
            name: 'menHairLoss_archived_moodDisorders_yes_ans',
            placeholder:
              'Can you tell us more about your mood disorder and whether it is controlled or uncontrolled?'
          }
        },
        {
          key: 'menHairLoss_archived_moodDisorders_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Do you plan on having children soon?',
    field: 'menHairLoss_archived_planOnHavingChildrenSoon',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_archived_planOnHavingChildrenSoon_yes',
          value: 'Yes'
        },
        {
          key: 'menHairLoss_archived_planOnHavingChildrenSoon_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'What other information or questions do you have for the doctor?',
    field: 'menHairLoss_archived_otherInformationOrQuestions',
    type: 'info',
    answer: {
      name: 'menHairLoss_archived_otherInformationOrQuestions',
      type: 'text',
      placeholder: ''
    }
  },
  {
    label: 'Consent Form for Hair Loss Treatment',
    educationalSlide: `
     <h1>Consent Form for Hair Loss Treatment</h1>

    <h2>Purpose of Treatment</h2>
    <p><strong>Finasteride:</strong> An oral medication that inhibits the conversion of testosterone to dihydrotestosterone (DHT), a hormone linked to hair loss. It helps slow hair loss and may promote regrowth.</p>
    <p><strong>Minoxidil:</strong> A topical solution that stimulates hair follicles to promote hair growth. It increases blood flow to the scalp.</p>
    <p><strong>GUK-Cu:</strong> A copper peptide complex believed to stimulate hair growth by enhancing blood flow and supporting scalp health.</p>

    <h2>Potential Benefits</h2>
    <p>These treatments aim to slow hair loss, promote new hair growth, and improve hair density and appearance.</p>

    <h2>Contraindications</h2>
    <h3>Finasteride</h3>
    <ul>
        <li>Individuals with liver disease</li>
        <li>Those with a history of prostate cancer</li>
        <li>Anyone allergic to finasteride or its components</li>
        <li>Women who are or may become pregnant should not handle finasteride tablets</li>
    </ul>
    <h3>Minoxidil</h3>
    <ul>
        <li>Individuals with scalp conditions like dermatitis or psoriasis</li>
        <li>Those allergic to minoxidil or its components</li>
    </ul>
    <h3>GUK-Cu</h3>
    <ul>
        <li>Should not be used by individuals allergic to copper peptides or any of its components</li>
    </ul>

    <h2>Potential Risks and Side Effects</h2>
    <h3>Finasteride</h3>
    <ul>
        <li>Sexual dysfunction (decreased libido, erectile dysfunction)</li>
        <li>Breast tenderness or enlargement</li>
        <li>Depression or mood changes</li>
        <li>Allergic reactions</li>
        <li>Possible effect on PSA levels used in prostate cancer screening</li>
    </ul>
    <h3>Minoxidil</h3>
    <ul>
        <li>Scalp irritation, itching, or dryness</li>
        <li>Unwanted facial or body hair growth</li>
        <li>Changes in blood pressure or heart rate (rare)</li>
    </ul>
    <h3>GUK-Cu</h3>
    <ul>
        <li>Scalp irritation</li>
        <li>Allergic reactions</li>
    </ul>

    <h2>Monitoring and Follow-up</h2>
    <p>Regular monitoring is recommended to assess effectiveness and detect any side effects. Inform your healthcare provider of any adverse reactions or concerns.</p>

    <h2>Alternative Treatments</h2>
    <ul>
        <li>Hair transplant surgery</li>
        <li>Low-level laser therapy</li>
        <li>Platelet-rich plasma (PRP) therapy</li>
        <li>Lifestyle changes and acceptance of hair loss</li>
    </ul>

    <h2>Patient Responsibilities</h2>
    <ul>
        <li>Use medications exactly as prescribed</li>
        <li>Report any side effects promptly</li>
        <li>Keep all follow-up appointments</li>
        <li>Inform your provider of any changes in your health status or medications</li>
    </ul>    

    <footer>
        <p>&copy; 2024 Beluga Health. All Rights Reserved.</p>
        <p>This document and its contents are protected by copyright law. Clients of Beluga Health are granted permission to copy the content solely for the purpose of integrating with Beluga Health services and systems. Any other use, reproduction, distribution, or transmission of this document or its content, in whole or in part, is strictly prohibited without the prior written permission of Beluga Health. For permission requests, contact Beluga Health at <a href="mailto:info@belugahealth.com">info@belugahealth.com</a>.</p>
    </footer>
    `,
    field: 'menHairLoss_archived_consent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'menHairLoss_archived_consent_agree',
          value:
            'I have read the above information, understand the risks, and wish to proceed.'
        }
      ]
    }
  }
];

export default questionsModels;
